module.exports = __webpack_public_path__ + "static/img/zt2-pic6.b65873b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic6.jpg
// module id = 2g/L
// module chunks = 171